// Имена по id для истории: из живых таблиц стора (та же колонка-название, что у history_label в базе);
// автор — как везде (человек из справочника, иначе кусок почты).
import { useCallback } from 'react';
import { data, useData, useTable } from '@core/store';
import { actorLabel } from '@core/people';
import type { Resolve } from './planner';
import { LABEL_COLUMN } from './labels';

export function useResolve(): Resolve {
  useData((s) => s.tables); // перерисовка при изменении таблиц
  return useCallback((table: string, id: string) => {
    const col = LABEL_COLUMN[table];
    if (!col) return null;
    const row = (data.store.getState().tables as Record<string, Map<string, Record<string, unknown>> | undefined>)[table]?.get(id);
    const v = row?.[col];
    return typeof v === 'string' ? v : null;
  }, []);
}

export function useActor(): (profileId: string | null) => { name: string; color: string; avatar: string | null } {
  const profiles = useTable('profile');
  const people = useTable('person');
  return useCallback((id: string | null) => actorLabel(id, profiles, people), [profiles, people]);
}
